var _rect, _rect2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCorrespondencePlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 288,
    height: 142,
    viewBox: "0 0 288 142",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 101,
    y: 27.5,
    width: 87,
    height: 87,
    rx: 43.5,
    fill: "#F7F7F9"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 101,
    y: 27.5,
    width: 87,
    height: 87,
    rx: 43.5,
    stroke: "#CECEDA"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M120.5 66.5V83C120.5 83.875 120.781 84.5938 121.344 85.1562C121.906 85.7188 122.625 86 123.5 86H138.5C139.375 86 140.094 85.7188 140.656 85.1562C141.219 84.5938 141.5 83.875 141.5 83V66.5C141.438 63.5 140.406 61.0312 138.406 59.0938C136.469 57.0938 134 56.0625 131 56C128 56.0625 125.531 57.0938 123.594 59.0938C121.594 61.0312 120.562 63.5 120.5 66.5ZM144.5 66.5V83C144.5 84.125 144.219 85.125 143.656 86H165.5C166.375 86 167.094 85.7188 167.656 85.1562C168.219 84.5938 168.5 83.875 168.5 83V66.5C168.438 63.5 167.406 61.0312 165.406 59.0938C163.469 57.0938 161 56.0625 158 56H139.531C141.031 57.25 142.219 58.7812 143.094 60.5938C144.031 62.4062 144.5 64.375 144.5 66.5ZM123.5 89C121.812 88.9375 120.406 88.3438 119.281 87.2188C118.156 86.0938 117.562 84.6875 117.5 83V66.5C117.625 62.6875 118.938 59.5 121.438 56.9375C124 54.4375 127.188 53.125 131 53H158C161.812 53.125 165 54.4375 167.562 56.9375C170.062 59.5 171.375 62.6875 171.5 66.5V83C171.438 84.6875 170.844 86.0938 169.719 87.2188C168.594 88.3438 167.188 88.9375 165.5 89H138.5H123.5ZM128 65H134C134.938 65.0625 135.438 65.5625 135.5 66.5C135.438 67.4375 134.938 67.9375 134 68H128C127.062 67.9375 126.562 67.4375 126.5 66.5C126.562 65.5625 127.062 65.0625 128 65ZM149 65H158H163.25C164.625 65.125 165.375 65.875 165.5 67.25V74.75C165.375 76.125 164.625 76.875 163.25 77H158.75C157.375 76.875 156.625 76.125 156.5 74.75V68H149C148.062 67.9375 147.562 67.4375 147.5 66.5C147.562 65.5625 148.062 65.0625 149 65ZM159.5 74H162.5V68H159.5V74Z",
    fill: "#706B85"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorrespondencePlaceholder);
export default __webpack_public_path__ + "static/media/correspondence-placeholder.3de326b7b343c07690bc5df22e3b2a1b.svg";
export { ForwardRef as ReactComponent };